import { render, staticRenderFns } from "./PoweredBySentinel.vue?vue&type=template&id=74425227&scoped=true&"
import script from "./PoweredBySentinel.vue?vue&type=script&lang=js&"
export * from "./PoweredBySentinel.vue?vue&type=script&lang=js&"
import style0 from "./PoweredBySentinel.vue?vue&type=style&index=0&id=74425227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74425227",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VFooter,VImg})
